import {createReducer} from '../utils';
import {SHOW_TEXT_OVERLAY,DISMISS_TEXT_OVERLAY} from '../constants';

const initialState = {
    text: '',
    headline: '',
    download: '',
    downloadStr: '',
    download2: '',
    downloadStr2: '',
    isActive: false
};

export default createReducer(initialState, {
    [SHOW_TEXT_OVERLAY]: (state, payload) => {
       return Object.assign({}, state, {
            text: payload.text,
            headline: payload.headline,
            download: payload.download,
            download2: payload.download2,
            isActive: true,
            downloadStr: payload.downloadStr,
            downloadStr2: payload.downloadStr2
        });
    },
    [DISMISS_TEXT_OVERLAY]: (state, payload) => {
       return Object.assign({}, state, {
            isActive: false
        });
    }
});



// WEBPACK FOOTER //
// ./src/reducers/textoverlay.js